import { render, staticRenderFns } from "./TsCurrencyInput.vue?vue&type=template&id=220447e2&"
import script from "./TsCurrencyInput.vue?vue&type=script&lang=js&"
export * from "./TsCurrencyInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports